'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_demand_report', {
        template: '<daily-demand-report></daily-demand-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/daily/daily_demand_report.routes.js